export const xxsmall = 9;
export const xsmall = 10;
export const small = 12;
export const medium = 14;
export const large = 19;
export const big = 24;
export const title = 28;
export const superBig = 32;

export const textInput = 16;
export const iconTitle = 18;
export const unitChart = 11;
